module.exports = __webpack_public_path__ + "845402f0eeae64750d919e1ffec000ba.jpg";